var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/directbox-default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "directbox-default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6667 15.1667H5.33333C1.5 15.1667 1.5 13.1333 1.5 11.3333V10.6667C1.5 9.18 1.5 7.5 4.66667 7.5C5.46 7.5 5.75333 7.69333 6.16667 8C6.18667 8.02 6.21333 8.03333 6.23333 8.06L6.91333 8.78C7.48667 9.38667 8.52667 9.38667 9.1 8.78L9.78 8.06C9.8 8.04 9.82 8.02 9.84667 8C10.26 7.68667 10.5533 7.5 11.3467 7.5C14.5133 7.5 14.5133 9.18 14.5133 10.6667V11.3333C14.5 13.88 13.2133 15.1667 10.6667 15.1667ZM4.66667 8.5C2.5 8.5 2.5 9.18 2.5 10.6667V11.3333C2.5 13.16 2.5 14.1667 5.33333 14.1667H10.6667C12.6533 14.1667 13.5 13.32 13.5 11.3333V10.6667C13.5 9.18 13.5 8.5 11.3333 8.5C10.8533 8.5 10.7533 8.56 10.4667 8.77333L9.82 9.46C9.34 9.96667 8.69333 10.2467 8 10.2467C7.30667 10.2467 6.66 9.96667 6.18 9.46L5.53333 8.77333C5.24667 8.56 5.14667 8.5 4.66667 8.5Z",
    fill: "#949DA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6663 8.5026C12.393 8.5026 12.1663 8.27594 12.1663 8.0026V4.0026C12.1663 2.51594 12.1663 1.83594 9.99967 1.83594H5.99967C3.83301 1.83594 3.83301 2.51594 3.83301 4.0026V8.0026C3.83301 8.27594 3.60634 8.5026 3.33301 8.5026C3.05967 8.5026 2.83301 8.27594 2.83301 8.0026V4.0026C2.83301 2.51594 2.83301 0.835938 5.99967 0.835938H9.99967C13.1663 0.835938 13.1663 2.51594 13.1663 4.0026V8.0026C13.1663 8.27594 12.9397 8.5026 12.6663 8.5026Z",
    fill: "#949DA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/request_icon.a49434c1a27f866ff93a4a6cb8e95dfd.svg";
export { ForwardRef as ReactComponent };